import './home.css'

function Footer() {
  return (
    <div className="main_page">
      <div className="footer xxx">Copyright © Woohooo 2012 - {new Date().getFullYear()}&nbsp;</div>
      <div className="footer xxx">
        CEO/CTO: <a href="mailto:ns@woohooo.dk">Nikolaj Strauss</a>
      </div>
    </div>
  )
}

export default Footer
